<template>
    <header>
        <div class="x-header-wrapper">
            <nav id="navigator" class="navigator">

                <!--S 移动导航条-->
                <transition name="fade" >
                    <div class="_m-nav-wrapper" v-if="xShow">
                        <ul class="_nav-items">
                            <li class="_nav-item" v-for="i in nav_items" @click="toggleMenu" >
                                <keep-alive>
                                    <router-link :to="i.href"> {{ i.item }} </router-link>
                                </keep-alive>
                            </li>
                        </ul>
                    </div>
                </transition>
                <!--E 移动导航条-->

                <!-- S logo-->
                <div class="_nav-logo"><a href=""><img :src="imgLogo" alt=""></a></div>
                <!-- E logo-->

                <!--S PC导航条-->
                <div class="_nav-wrapper">
                    <ul class="_nav-items">
                        <li class="_nav-item" v-for="i in nav_items"><router-link :to="i.href"> {{ i.item }} </router-link></li>
                    </ul>
                </div>
                <!--E PC导航条-->

                <!--S 移动菜单目录按钮   PC 隐藏-->
                <div class="menu-button" @click="toggleMenu">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                </div>
                <!--E 移动菜单目录按钮   PC 隐藏-->

            </nav>
        </div>
    </header>
</template>

<script>
//    import luan from '../../assets/images/x-header-logo.png'
    let url = '/static/images/'
export default {
    data(){
        return {
            imgLogo: url+'x-header-logo.png',
            xShow: false,
            nav_items: [
                { item: 'BLOG',href:'/blog'},
                { item: 'PRODUCTION',href:'/production'},
                { item: 'ABOUT',href:'/about'},
                { item: 'OTHER',href:'/other'}
            ]
        }
    },
    computed: {
        getMenuButton() {
            return document.querySelector('.menu-button')
        },
        getMNavWrapper() {
            return document.querySelector('._m-nav-wrapper')
        },
        getMNavItems() {
            return document.querySelector('._nav-items')
        }
    },
    methods:{
        toggleMenu() {
            this.xShow = !this.xShow
            if(this.getMenuButton.classList.toggle('cross')){
//                this.getMNavWrapper.classList.remove('xHide')
            }else {
            }
        }
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition:1s;
    opacity: 1;
    transform: translateY(0px);
}
.fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(-150px);

}

/*.xHide{  display: none;  }*/
.xShow{  display: block;  }

.x-header-wrapper{top: 0;  left: 0;  right: 0;  height: 180px;  width: 100%; font-weight:900; background-color: #fff;}
.navigator{max-width: 1260px; margin: 0 auto; height: 180px; display: flex; flex-direction: row; flex-wrap: nowrap;align-items: center;box-sizing: border-box;}

/*S logo*/
._nav-logo{margin-left: 100px; width: 100px; height: 100px;display:inline-block; flex-grow: 1; text-align: left;}
._nav-logo>a{ width: 100px; height: 100px; display:inline-block;}
._nav-logo>a>img{width: 100%; height: 100%;}
/*background: url("../../assets/images/x-header-logo.png") no-repeat; background-size: 100% 100%;*/
/*E logo*/

/*S PC导航条 & 动画*/
._nav-wrapper{margin-right: 100px;}
._nav-wrapper>._nav-items{display: flex; flex-direction: row; flex-wrap: nowrap;align-items: center;box-sizing: border-box; text-align: right;}
._nav-wrapper>._nav-items>li{margin-right: 50px; display: inline-block; padding: 0 20px;}
._nav-wrapper>._nav-items>li>a{position: relative;  font-size: 15px; color: #000; display: inline-block;}
._nav-wrapper>._nav-items>li>a:after{  content: '';  position: absolute;  left: 0;  bottom: 2px;  background: currentColor;  display: block;
    height: 2px;
    width: 100%;
    opacity: 0;
    transform: scaleX(0);
    transition: all .2s cubic-bezier(0.18, 0.89, 0.17, 0.88), opacity .15s ease;
}
._nav-wrapper>._nav-items>li>a:hover::after{
    transform: scaleX(1);
    opacity: 1;
}
/*S PC导航条 & 动画*/


/*S 移动菜单目录按钮*/
._m-nav-wrapper{
    z-index: 100;
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
}

._m-nav-wrapper>._nav-items{
    padding-top: 100px;
    display: flex;
    -webkit-display: inline-flex;
    flex-direction: column;
    align-items: center;
    align-content: space-around;
    font-size: 30px;
    line-height: 30px;
    width: 100%;
    height: 100%;
}
._m-nav-wrapper>._nav-items>li{margin-top: 10px;padding: 5px 0}
._m-nav-wrapper>._nav-items>li>a{color: #000;}
/*E 移动菜单目录按钮*/


/*S 移动菜单目录按钮  PC 隐藏*/
.menu-button {  display: none;  position: absolute;  right: 50px; top: 50px;  padding: 15px;  cursor: pointer;  background-color: #fff;
    -webkit-transition: .3s;
    transition: .3s;
    z-index: 100;
}
.menu-button .bar:nth-of-type(1) {  margin-top: 0px; }
.menu-button .bar:nth-of-type(3) {  margin-bottom: 0px;  }
.bar {  position: relative;  display: block;  width: 40px;  height: 5px;  margin: 10px auto;  background-color: #000;  border-radius: 10px;
    -webkit-transition: .3s;
    transition: .3s;
}
.menu-button:hover .bar:nth-of-type(1) {
    -webkit-transform: translateY(1.5px) rotate(-4.5deg);
    -ms-transform: translateY(1.5px) rotate(-4.5deg);
    transform: translateY(1.5px) rotate(-4.5deg);
}
.menu-button:hover .bar:nth-of-type(2) {  opacity: .9;  }
.menu-button:hover .bar:nth-of-type(3) {
    -webkit-transform: translateY(-1.5px) rotate(4.5deg);
    -ms-transform: translateY(-1.5px) rotate(4.5deg);
    transform: translateY(-1.5px) rotate(4.5deg);
}

.cross .bar:nth-of-type(1) {
    -webkit-transform: translateY(15px) rotate(-45deg);
    -ms-transform: translateY(15px) rotate(-45deg);
    transform: translateY(15px) rotate(-45deg);
}
.cross .bar:nth-of-type(2) {  opacity: 0;  }
.cross .bar:nth-of-type(3) {
    -webkit-transform: translateY(-15px) rotate(45deg);
    -ms-transform: translateY(-15px) rotate(45deg);
    transform: translateY(-15px) rotate(45deg);
}
.cross:hover .bar:nth-of-type(1) {
    -webkit-transform: translateY(13.5px) rotate(-40.5deg);
    -ms-transform: translateY(13.5px) rotate(-40.5deg);
    transform: translateY(13.5px) rotate(-40.5deg);
}
.cross:hover .bar:nth-of-type(2) {  opacity: .1;  }
.cross:hover .bar:nth-of-type(3) {
    -webkit-transform: translateY(-13.5px) rotate(40.5deg);
    -ms-transform: translateY(-13.5px) rotate(40.5deg);
    transform: translateY(-13.5px) rotate(40.5deg);
}
/*E 移动菜单目录按钮   PC 隐藏*/


/*S css动画*/

/*E css动画*/


/*S  屏幕小于880px*/
@media screen and (max-width: 880px){
    ._nav-wrapper>._nav-items{  display: none;  padding: 0;  flex-grow: 1;}
    .menu-button{display: block;}
    ._m-nav-wrapper{display: block;}
}
/*E  屏幕小于880px*/

/*S  屏幕小于640px*/
@media screen and (max-width: 640px){
    ._nav-logo{  margin-left: 40px; width: 80px; height: 80px; margin-top: -50px;}
}
/*E  屏幕小于640*/
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue